import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SharedForm from '../shared/SharedForm';
import Input from '../shared/inputs/Input';

export default class AdviceRecordForm extends Component {
  static propTypes = {
    authenticityToken: PropTypes.string.isRequired,
    adviceTypes: PropTypes.object.isRequired,
    requestStateCallback: PropTypes.func.isRequired,
    adviceRecordId: PropTypes.number,
    tenant: PropTypes.string.isRequired,
    clientId: PropTypes.number.isRequired
  }

  static MEGABYTE = 1024 * 1024;
  static FILE_SIZE_LIMIT = 10 * AdviceRecordForm.MEGABYTE;
  static UPLOAD_COMPLETE_REDIRECT_DELAY = 100;

  constructor(props) {
    super(props);
    this.state = {
      dragover: false,
      selectedFilename: null,
      formValid: false
    };
  }

  submitHandler = (e) => {
    e.preventDefault();

    let req = new XMLHttpRequest();
    this.req = req;

    // register handlers
    req.onreadystatechange = this._finishedHandler;
    // Implement if progress updates are required
    // req.upload.onprogress = this._onprogressHandler;
    req.upload.onloadstart = this._onloadstartHandler;
    req.upload.onerror = this._onerrorHandler;
    req.upload.onabort = this._onabortHandler;

    let form = document.getElementsByClassName('js-advice-record-form')[0];

    // open connection
    req.open(form.getAttribute("method"), form.action);
    req.setRequestHeader("Accept", "application/json");
    req.responseType = "json";

    // send data
    let formData = new FormData(form);
    if (this.state.file) {
      formData.append('document[file]', this.state.file);
    }
    req.send(formData);
  }

  _finishedHandler = () => {
    if (this._isSuccessfulResponse(this.req)) {
      // Show success text/modal
      let redirectPath = this.req.response.redirect_path;
      (redirectPath === undefined) && (redirectPath = JSON.parse(this.req.response).redirect_path);
      setTimeout(function () {
        window.gtag && window.gtag('event', 'document_created', { 'event_category': 'Documents' });
        window.location = redirectPath;
      }, AdviceRecordForm.UPLOAD_COMPLETE_REDIRECT_DELAY);
    } else if (this._isFailureResponse(this.req)) {
      // Show error modal as a result of a failed upload
      this.props.requestStateCallback('error');
    }
  }

  _isSuccessfulResponse(req) {
    return req.readyState === req.DONE && req.response && (req.status >= 200 && req.status < 300);
  }

  _isFailureResponse(req) {
    return req.readyState === req.DONE;
  }

  _onprogressHandler = (evt) => {
    // Not implemented
  }

  _onloadstartHandler = (evt) => {
    // Show progress modal
    this.props.requestStateCallback('progress');
  }

  _onerrorHandler = (evt) => {
    // Show error modal
    this.props.requestStateCallback('error');
  }

  _onabortHandler = (evt) => {
    // Show error modal as a result of an abort
    this.props.requestStateCallback('error');
  }

  handleDragOver = (e) => {
    e.preventDefault();
    this.setState({ dragover: true });
  }

  handleDragLeave = (e) => {
    this.setState({ dragover: false });
  }

  handleDrop = (e) => {
    e.preventDefault();
    let file = e.dataTransfer.files[0];

    this.setState({
      dragover: false,
      selectedFilename: file.name,
      file: file,
      formValid: true
    });
  }

  handleFileSelect = (e) => {
    e.preventDefault();
    let fileInput = document.getElementById("js-advice-file-upload");
    fileInput.click();
  }

  handleFileSelected = (e) => {
    this.setState({
      selectedFilename: e.target.files[0].name,
      formValid: true
    });
  }

  toggleAdviceRecordFields() {
    if (this.props.adviceRecordId) {
      return <input type="hidden" name="advice_record[id]" defaultValue={this.props.adviceRecordId} />
    } else {
      return (
        <div className='form-group'>
          <Input name="advice_record[name]"
            label="Give this record a name"
            isHalf={true}
            validations={[]}>
          </Input>
          <Input inputType="select"
            name="advice_record[advice_type]"
            label="Title"
            isHalf={true}>
            {Object.keys(this.props.adviceTypes).map((value, _i) => (
              <option key={value} value={value}>{this.props.adviceTypes[value]}</option>
            ))}
          </Input>
        </div>
      )
    }
  }

  toggleUploadArea() {
    if (this.state.selectedFilename) {
      return (
        <div>
          <span className='upload-icon gci-icon-document' />
          <p className="upload-hint">{this.state.selectedFilename}</p>
        </div>
      )
    } else {
      return (
        <div>
          <span className='upload-icon gci-icon-upload' />
          <p className="upload-hint">Drag & drop or click to select your file</p>
        </div>
      )
    }
  }

  render() {
    return (
      <div>
        <SharedForm actionUrl={`/clients/${this.props.clientId}/advice_records`} methodType={this.props.adviceRecordId ? "PUT" : "POST"} formAttrs={{ className: "js-advice-record-form" }} authenticityToken={this.props.authenticityToken}>
          <fieldset className='form__input'>
            {this.toggleAdviceRecordFields()}
            <div className="clearfix" />
            <div className='form-group' style={{ padding: '1rem' }}>
              <div className={`js-drop-area drop-area ${this.state.dragover ? 'drop-area-active' : ''}`} onClick={this.handleFileSelect} onDrop={this.handleDrop} onDragOver={this.handleDragOver} onDragLeave={this.handleDragLeave}
                style={{ width: '100%', height: '200px' }}>

                <div className="drop-area__content text-center">
                  {this.toggleUploadArea()}
                </div>
              </div>
              <label style={{ visibility: 'hidden' }}>
                <input id="js-advice-file-upload" type="file" name="document[file]" onChange={this.handleFileSelected} />
              </label>
            </div>
          </fieldset>
          <div className="form__actions form__actions--multiple text-center">
            <a href="#" data-close="" className="button button--secondary">Cancel</a>
            <input type="submit" name="submit" value="Upload" className="button" disabled={!this.state.formValid} onClick={this.submitHandler} />
          </div>
        </SharedForm>
      </div>
    );
  }
}
